'use client'

import clsx from 'clsx'
import { useContentShareControls, useContentShareState } from 'amazon-chime-sdk-component-library-react'
import { ComputerDesktopIcon } from '@heroicons/react/24/outline'
import { useTranslations } from '@/lib/next-shim'

export function ScreenShareControl() {
  const { toggleContentShare } = useContentShareControls()
  const { isLocalUserSharing } = useContentShareState()
  const t = useTranslations('meetingControls.screenShare')
  const tooltip = isLocalUserSharing ? t('stop') : t('start')

  return (
    <div className="ds-tooltip" data-tip={tooltip}>
      <button
        type="button"
        className={clsx(
          'flex rounded-full bg-white/10 p-2 text-white shadow-sm hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600',
          {
            'bg-blue-500': isLocalUserSharing,
          }
        )}
        onClick={() => toggleContentShare()}
        aria-label={tooltip}
      >
        <ComputerDesktopIcon className="h-5 w-5" />
      </button>
    </div>
  )
}
